import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import LoadingIcon from "../../shared/LoadingIcon";
import {ErrorPage} from "../../shared/ErrorPage";
import {reportDownloadAllRequest, reportEmailAllRequest,} from "../../api/Api";
import {ROUTES} from "../../utils/RouteConstants";
import {getMembers} from "../../api/RestCallHelper";
import StatementsSelectedMembers from "./StatementScreenSelectedMembersList";
import StatementScreenList from "./StatementScreenList";
import BaseFormPage from "../baseFormPage/BaseFormPage";
import StatementScreenActions from "./StatementScreenActions";
import FormHeader from "../../shared/FormHeader";
import {NarrowFormPage} from "../../styles/globalStyles";
import {StatementFormDiv, StatementSelectedListDiv} from "./StatementScreenStyles";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import FetchState from "../../api/FetchState";
import useUserData from "../../hooks/useUserData";

export default function StatementScreen() {

  let history = useHistory();
  let location = useLocation();

  const user = useUserData();
  const dispatch = useFeedbackDispatch();
  const [fetchState, setFetchState] = useState(FetchState.LOADING);

  const [checked, setChecked] = useState([]);
  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);

  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const [feedback, setFeedback] = useState({
    message: "",
    open: false,
    time: 0,
    closeType: null,
  });

  const close = (event, reason) => {
    console.log("In Statements Screen close callback");
    if (reason === 'clickaway') return;

    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    //console.log(value);
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  useEffect(() => {

    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request
    getMembers((x) => {setData(x); setInitialData(x); }, true, dispatch, setFetchState, close, history, location);

    // once the request is sent, update state again
    if (isMounted.current)
        // only update if we are still mounted
      setIsSending(false);

  }, [setData, setIsSending]);

  const downloadAllStatements = useCallback(
    async (x) => {
      // don't send again while we are sending
      if (isSending) return;

      // update state
      setIsSending(true);
      // send the actual request

      var list = Object.assign([], x);

      var list2 = Object.assign([], x);

      async function getStatements() {
        var time = 3000;

        let resp;

        let req = "v1/reports/memberStatement/";

        list.forEach(function (part, index) {

          this[index] = req + part.id;
        }, list);

        resp = await reportDownloadAllRequest(list);

        resp.data.forEach(function (part, index) {

          const url = window.URL.createObjectURL(new Blob([part.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          let filename =
            `${process.env.REACT_APP_ORG_NAME}: ` +
            list2[index].name +
            " " +
            list2[index].surname +
            " " +
            date.toDateString() +
            ".pdf";
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        }, resp.data);

        if (resp.message === "SUCCESS") {
          setFeedback({
            severity: "success",
            message: "Success",
            open: true,
            time: time,
            closeType: close,
          });
        } else if (resp.message === "unauthorized") {

          history.push(ROUTES.LOGIN, { last: location.pathname, data: location.state });
        } else if (resp.message === "no connection") {
          time = 6000;
          setFeedback({
            severity: "error",
            message: "Check your internet connection",
            open: true,
            time: time,
            closeType: close,
          });
        } else if (resp.message === "timeout") {
          time = 6000;
          setFeedback({
            severity: "error",
            message: "Request timed out. Please Try Again",
            open: true,
            time: time,
            closeType: close,
          });
        }
      }

      getStatements();

      // once the request is sent, update state again
      if (isMounted.current)
        // only update if we are still mounted
        setIsSending(false);
    },
    [isSending, location, history]
  ); // update the callback if the state changes

  const emailAllStatements = useCallback(
    async (x) => {
      // don't send again while we are sending
      if (isSending) return;

      // update state
      setIsSending(true);
      // send the actual request

      var list = Object.assign([], x);

      async function getStatements() {
        var time = 3000;

        let resp;

        let req = "v1/reports/memberStatement/";

        list.forEach(function (part, index) {

          this[index] = req + part.id + "/" + part.email;
        }, list);

        resp = await reportEmailAllRequest(list);

        if (resp.message === "SUCCESS") {
          setFeedback({
            severity: "success",
            message: "Success",
            open: true,
            time: time,
            closeType: close,
          });
        } else if (resp.message === "unauthorized") {
          history.push(ROUTES.LOGIN, { last: location.pathname, data: location.state });
        } else if (resp.message === "no connection") {
          time = 6000;
          setFeedback({
            severity: "error",
            message: "Check your internet connection",
            open: true,
            time: time,
            closeType: close,
          });
        } else if (resp.message === "timeout") {
          time = 6000;
          setFeedback({
            severity: "error",
            message: "Request timed out. Please Try Again",
            open: true,
            time: time,
            closeType: close,
          });
        }
      }

      getStatements();

      // once the request is sent, update state again
      if (isMounted.current)
        // only update if we are still mounted
        setIsSending(false);
    },
    [isSending, location, history]
  ); // update the callback if the state changes

  if (FetchState.SUCCESS === fetchState) {
    return (
        <NarrowFormPage>
          <StatementFormDiv>
            <BaseFormPage

                header = {
                  <FormHeader
                      heading= "Statements"
                  />
                }

                form={
                  <>
                    <StatementScreenActions
                        initialData={initialData}
                        data={data}
                        setData={setData}
                        user={user}
                        isSending={isSending}
                    />

                    <StatementScreenList
                        handleToggle={handleToggle}
                        members={data}
                        checked={checked}
                    />
                  </>

                }
            />
          </StatementFormDiv>

          <StatementSelectedListDiv>
            <StatementsSelectedMembers
                selectedMembers={checked}
                setChecked={setChecked}
                feedback={feedback}
                setFeedback={setFeedback}
                close={close}
                isSending={isSending}
                setIsSending={setIsSending}
                isMounted={isMounted}
            />
          </StatementSelectedListDiv>
        </NarrowFormPage>
    )}
  else if (FetchState.ERROR === fetchState) return <ErrorPage />
  else if (FetchState.LOADING === fetchState) return <LoadingIcon />
}
